module.exports = __webpack_public_path__ + "img/slide1.c259edba.jpg";